import API from './API.js';
export default class Tags extends API {
    constructor() {
        super('Library/tags');
    }

}
